/**
 * 页面组件序号：与动作合集绑定区同语义。
 * 输入 1-based 目标位，splice 挪动；非法则还原显示值。
 *
 * @param {unknown[]} list
 * @param {number} fromIndex
 * @param {string} rawInput
 * @returns {{ ok: true, nextList: unknown[] } | { ok: false, restore: string, message: string }}
 */
export function moveByOrderInput(list, fromIndex, rawInput) {
  const rows = Array.isArray(list) ? list.slice() : [];
  const max = rows.length;
  const restore = String(fromIndex + 1);
  const parsed = Number.parseInt(String(rawInput || "").trim(), 10);
  if (!Number.isFinite(parsed) || parsed < 1 || parsed > max) {
    return {
      ok: false,
      restore,
      message: `请输入 1～${max} 的整数`,
    };
  }
  const toIndex = parsed - 1;
  if (toIndex === fromIndex) {
    return { ok: false, restore, message: "" };
  }
  const [moved] = rows.splice(fromIndex, 1);
  rows.splice(toIndex, 0, moved);
  return { ok: true, nextList: rows };
}

/**
 * 分类下拉展示名：下线分类带标记，避免误当成上线。
 */
export function categoryOptionLabel(cat) {
  if (!cat) {
    return "";
  }
  if (Number(cat.status) === 1) {
    return cat.name || "";
  }
  return `${cat.name || ""}（下线）`;
}
